// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup[data-v-8a66dc02]{align-items:center;background-color:rgba(0,0,0,.2);bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:99}.popup .popup-inner[data-v-8a66dc02]{background:#fff;padding:20px}.popup .popup-inner .popup-close[data-v-8a66dc02]{right:6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
